import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface GeneralState {
  modal: {
    show: boolean;
    hide: boolean;
    data: any;
    modalName: string | null | undefined;
  };
  popup: {
    show: boolean;
    hide: boolean;
    data: any;
    popupName: string | null | undefined;
  };
  showWizardModal: boolean;
  showPageLoaderCounter: number;
  showPageLoader: boolean;
}

const initialState: GeneralState = {
  modal: {
    show: false,
    hide: false,
    data: null,
    modalName: null,
  },
  popup: {
    show: false,
    hide: false,
    data: null,
    popupName: null,
  },
  showWizardModal: false,
  showPageLoaderCounter: 0,
  showPageLoader: false,
};

export const generalSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    setShowWizardModal: (state, action: PayloadAction<boolean>) => {
      state.showWizardModal = action.payload;
    },
    // modal
    handleResetModalAction: (state: GeneralState) => {
      state.modal = initialState.modal;
    },
    handleShowModalAction: {
      reducer: (
        state: GeneralState,
        action: PayloadAction<{ data: any; modalName: string }>,
      ) => {
        state.modal = {
          show: true,
          hide: false,
          data: action.payload.data,
          modalName: action.payload.modalName,
        };
      },
      prepare: (modalName: string, data?: any) => {
        return {
          payload: {
            modalName,
            data,
          },
        };
      },
    },
    handleHideModalAction: (
      state: GeneralState,
      action: PayloadAction<{ data: any; modalName: string } | undefined>,
    ) => {
      state.modal = {
        show: false,
        hide: true,
        data: action?.payload?.data,
        modalName: action?.payload?.modalName,
      };
    },
    // popup
    handleHidPopupAction: (state: GeneralState) => {
      state.popup = { show: false, hide: true, data: null, popupName: null };
    },
    handleResetPopupAction: (state: GeneralState) => {
      state.popup = initialState.popup;
    },
    handleShowPopupAction: {
      reducer: (
        state: GeneralState,
        action: PayloadAction<{ data?: any; popupName: string }>,
      ) => {
        state.popup = {
          show: true,
          hide: false,
          data: action.payload.data,
          popupName: action.payload.popupName,
        };
      },
      prepare: (popupName: string, data?: any) => {
        return {
          payload: {
            popupName,
            data,
          },
        };
      },
    },
    setShowPageLoader: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        state.showPageLoaderCounter += 1;
      } else {
        state.showPageLoaderCounter -= 1;
      }

      state.showPageLoader = state.showPageLoaderCounter > 0; 
    },
  },
});

export const {
  handleHideModalAction,
  handleResetModalAction,
  handleShowModalAction,
  handleHidPopupAction,
  setShowWizardModal,
  setShowPageLoader
} = generalSlice.actions;

export default generalSlice.reducer;
